import { render, staticRenderFns } from "./modifier.vue?vue&type=template&id=a4fec830&"
import script from "./modifier.vue?vue&type=script&lang=js&"
export * from "./modifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports